import React from 'react';
import { Link } from 'react-router-dom';
import {  Card, CardFooter } from 'reactstrap';

export default function CardButton(props) {
  const { title, subtitle, buttonLabel, buttonLink } = props;

  return (
    <Card className='card-shadow-primary card-border text-white mb-3' color='primary'>
      <div className='dropdown-menu-header'>
        <div className='dropdown-menu-header-inner bg-primary'>
          <div className='menu-header-content'>
            <div>
              <h5 className='menu-header-title'>{title}</h5>
              <h6 className='menu-header-subtitle'>{subtitle}</h6>
            </div>
          </div>
        </div>
      </div>
      <CardFooter className='text-center d-block'>
        <Link
          to={buttonLink}
          className='btn btn-shadow-dark btn-wider btn-dark'
        >
          {buttonLabel}
        </Link>
      </CardFooter>
    </Card>
  );
}
